var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fill: "rgba(19, 37, 74, 0.5)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.007 9.586V0h2v9.586L12.3 5.293l1.414 1.414-6 6a1 1 0 0 1-1.414 0l-6-6 1.414-1.414 4.293 4.293z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownDisabled);
export default __webpack_public_path__ + "static/media/arrowDownDisabled.76a266fdb31df339642a89f19ae69717.svg";
export { ForwardRef as ReactComponent };